module.exports = __webpack_public_path__ + "img/404.419619fe.svg";